// extracted by mini-css-extract-plugin
module.exports = {"Calendar":"calendar_Calendar__3z-9P"};